/*
 * PDP info sections (Technical data, Additional information, FAQ).
 *
 *  - Accordion: inside one [data-info-acc] group only one <details> is open at a
 *    time; opening one closes the others, with a height ease.
 *  - Reveal: [data-info-fx] elements fade up as they scroll into view.
 *
 * Everything degrades to plain <details> and visible content without JS.
 */
(function () {
  if (window.__pagInfoInit) return;
  window.__pagInfoInit = true;

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 0.8, 0.24, 1)';

  function bodyOf(details) {
    return details.querySelector('[data-info-body]');
  }

  function closeOne(d) {
    var b = bodyOf(d);
    if (!d.open) return;
    if (reduce || !b || !b.animate) {
      d.open = false;
      return;
    }
    var h = b.offsetHeight;
    b.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 300, easing: EASE }).onfinish = function () {
      d.open = false;
    };
  }

  function openOne(d) {
    d.open = true;
    var b = bodyOf(d);
    if (reduce || !b || !b.animate) return;
    var h = b.offsetHeight;
    b.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 380, easing: EASE });
  }

  function initAccordion(group) {
    var items = [].slice.call(group.querySelectorAll('details'));
    items.forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          closeOne(d);
        } else {
          items.forEach(function (o) {
            if (o !== d) closeOne(o);
          });
          openOne(d);
        }
      });
    });
  }

  function initReveal(scope) {
    var els = [].slice.call(scope.querySelectorAll('[data-info-fx]'));
    els.forEach(function (el, i) {
      el.style.setProperty('--info-d', Math.min(i, 6) * 60 + 'ms');
    });
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function init(scope) {
    [].forEach.call(scope.querySelectorAll('[data-info-acc]:not([data-info-ready])'), function (g) {
      g.setAttribute('data-info-ready', '');
      initAccordion(g);
    });
    initReveal(scope);
  }

  root.classList.add('js-info');
  init(document);

  // Theme editor re-renders a section in place.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    [].forEach.call(e.target.querySelectorAll('[data-info-fx]'), function (el) {
      el.classList.add('is-in');
    });
  });
})();
